import * as tslib_1 from "tslib";
import { HttpClient } from '@angular/common/http';
import { Subject } from 'rxjs';
import { CrudService } from '@ml/shared/services/crud.service';
import { tap } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var TaskLocationService = /** @class */ (function (_super) {
    tslib_1.__extends(TaskLocationService, _super);
    function TaskLocationService(http) {
        var _this = _super.call(this, http, false) || this;
        _this.http = http;
        /**
         * Emit values when we add new task locations so the Related Task table and Locations
         * Table can be updated in real time
         */
        _this.added = new Subject();
        /**
         * Emit values when we remove task locations so the Related Task table and Locations
         * Table can be updated in real time
         */
        _this.removed = new Subject();
        return _this;
    }
    Object.defineProperty(TaskLocationService.prototype, "url", {
        get: function () {
            return "tasks/" + this.taskId + "/locations";
        },
        enumerable: true,
        configurable: true
    });
    TaskLocationService.prototype.setStatus = function (taskLocation) {
        var url = "tasks/" + taskLocation.task + "/locations";
        var body = {
            status: taskLocation.status
        };
        return this.http.patch(url + "/" + taskLocation.id, body);
    };
    TaskLocationService.prototype.bulkCreate = function (taskLocations) {
        var _this = this;
        return this.http
            .post(this.url + "/create", taskLocations)
            .pipe(tap(function (_taskLocations) {
            return _this.added.next({
                task: _this.taskId,
                taskLocations: _taskLocations
            });
        }));
    };
    TaskLocationService.prototype.bulkRemove = function (taskLocations) {
        var _this = this;
        return this.http.post(this.url + "/remove", taskLocations).pipe(tap(function () {
            return _this.removed.next({
                task: _this.taskId,
                taskLocations: taskLocations
            });
        }));
    };
    TaskLocationService.prototype.added$ = function () {
        return this.added.asObservable();
    };
    TaskLocationService.prototype.removed$ = function () {
        return this.removed.asObservable();
    };
    TaskLocationService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function TaskLocationService_Factory() { return new TaskLocationService(i0.ɵɵinject(i1.HttpClient)); }, token: TaskLocationService, providedIn: "root" });
    return TaskLocationService;
}(CrudService));
export { TaskLocationService };
